// Интеграция Adv.Cace для программ
function advCaceProgram() {
  let targetUrl = location.href.split('/');

  //Включаем на странице программ и передаем имя программы
  if (!targetUrl.includes('program')) {
    return;
  } 

  try { 
    const title = document.querySelector('.home__title')?.textContent,
      programName = title.slice(title.indexOf("«") + 1, title.indexOf("»"));

    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
      pageType: 2,
      user: {
        email: '',
      },
      currentLead: {
        leadid: '',
        name: programName,
      },
    });
  } catch (e) {
    console.log(e);
  }
}

export default advCaceProgram;
